import React from 'react';
import { Check2FAProvider } from './context';
import { LoginContent } from './LoginContent';

export const Login: React.FC = () => (
	<Check2FAProvider>
		<LoginContent />
	</Check2FAProvider>
);
